import script from "./myprofile.vue?vue&type=script&setup=true&lang=js"
export * from "./myprofile.vue?vue&type=script&setup=true&lang=js"

import "./myprofile.vue?vue&type=style&index=0&id=e5c33a66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5c33a66"]])

export default __exports__